var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-width d-inline-flex flex-column"},[_c('div',{staticClass:"placeholder align-self-center"},[_c('div',{staticClass:"placeholder-body"},[_vm._v("' '")])])])
}]

export { render, staticRenderFns }